import { Link } from 'gatsby';
import { useState } from 'react';

// @todo remove header.css import after refactoring
import '../../styles/header.css';
import '../../styles/menu.css';

import { _ } from '../../utils/l10n';
import { Button } from '../generic/Button';
import { getContactButtonProps } from '../../utils/navigation';
import { MenuItems, NavLinks } from '../MenuItems';
import { NavigationButtons } from './NavigationButtons';
import { SignInButton } from '../generic/SignInButton';
import TrustwiseLogoPrimary from '../../assets/icons/trustwise-logo-primary.svg';
import TrustwiseLogoWhite from '../../assets/icons/trustwise-logo-white.svg';

// @todo consider mdx for menu items definitions
const mainMenuItems: NavLinks = {
  'solutions': 'Solutions',
  'use-cases': 'Use cases',
  'platform': {
    label: 'Platform',
    items: {
      'build-your-solution': 'Build Your Solution',
      'architecture': 'Architecture',
    },
  },
  'partner-services': {
    label: 'Partner Services',
    items: {
      'current-providers': 'Current Service Providers',
      'become-provider': 'Become a Service Provider',
    },
  },
  'about': {
    label: 'About us',
    items: {
      'company': 'Company',
      'team': 'Team',
      'our-partners': 'Our Network',
      'news': 'News',
    },
  },
};

export interface NavigationLinksProps {
  /**
   * Indicates whether current page is home page
   */
  isHomePage?: boolean;
  /**
   * Indicates whether logo should be dark
   */
  darkLogo?: boolean;
}

export const NavigationList = (
  {
    isHomePage,
    darkLogo = !isHomePage,
  }: NavigationLinksProps,
) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const trustwiseLogoSrc = darkLogo ?TrustwiseLogoPrimary : TrustwiseLogoWhite;
  const isSecondaryOrInverted = isHomePage || !darkLogo;

  return (
    <header className={`${isHomePage ? 'network-bg' : 'gradient-bg'}`}>
      <nav className={`nav-list ${isMobileMenuOpen ? ' mobile-menu-open' : ''}`}>
        <div className='left-nav'>
          <Link to='/'>
            <img src={trustwiseLogoSrc} alt='Trustwise logo' id='trustwise-logo' />
          </Link>
          <div className={`menu ${isHomePage ? 'network-bg' : 'gradient-bg'}`}>
            <MenuItems items={mainMenuItems} isMobileMenuOpen={isMobileMenuOpen} />
            <div className='menu-buttons'>
              <SignInButton className='sign-in-menu-button' isSecondary={isSecondaryOrInverted} />
              <Button {...getContactButtonProps(isSecondaryOrInverted)} />
            </div>
          </div>
        </div>
        <NavigationButtons
          isMobileMenuOpen={isMobileMenuOpen}
          setIsMobileMenuOpen={setIsMobileMenuOpen}
          isSecondary={isSecondaryOrInverted}
        />
      </nav>
    </header>
  );
}
